module.exports = __webpack_public_path__ + "img/nodtransferlight.png.07e41422.webp";